import React from 'react';

const Page404 = () => (
	<div>Page 404</div>
);

export default Page404;



// WEBPACK FOOTER //
// ./src/views/errors/404.js